import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../authentication/authentication.service';
import {OfficeAllocation} from '../lead-form-app/model/office-allocation.model';
import {CooperationInvitation} from './cooperation-invitation.model';
import {CooperationInvitationService, ResponseStatus} from './cooperation-invitation.service';
import {AgentService} from '../lead-form-app/service/agent.service';
import {MatDialog} from '@angular/material/dialog';
import {ErrorModalComponent} from '../errorhandler/error-modal/error-modal.component';
import {Location} from '@angular/common';
import {Office} from '../lead-form-app/model/office.model';

type FormState = 'LOADING' | 'NO_OFFICE_ALLOCATION' | 'CREATED' | 'DENIED' | 'ACCEPTED';

@Component({
  selector: 'app-cooperation-invitation-response',
  templateUrl: './cooperation-invitation-response.component.html',
  styleUrls: ['./cooperation-invitation-response.component.scss']
})
export class CooperationInvitationResponseComponent {

  providerAgent?: OfficeAllocation;

  providerAgentOptions: OfficeAllocation[];

  invitation: CooperationInvitation;

  loading: boolean = true;
  errOccurred: boolean;
  denying: boolean;
  accepting: boolean;
  code: string;

  constructor(private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService,
              private cooperationInvitationService: CooperationInvitationService,
              private agentService: AgentService, private matDialog: MatDialog,
              private location: Location) {
    this.authenticationService.triggerLogin();
    this.activatedRoute.queryParams.subscribe(params => {
      this.authenticationService.authenticatedUser.subscribe(u => {
        agentService.getAgentsOfCurrentUser().subscribe(
          agentPage => {
            if (agentPage?._embedded?.officeAllocations) {
              if (agentPage._embedded.officeAllocations.length > 1) {
                this.providerAgentOptions = agentPage._embedded.officeAllocations;
              }
              this.providerAgent = agentPage._embedded.officeAllocations[0];
            }
          },
        );
        if (u) {
          if (params.code) {
            this.errOccurred = false;
            this.code = params.code;
            cooperationInvitationService.getByCode(this.code).subscribe(i => {
                this.invitation = i;
                this.loading = false;
              },
              e => {
                this.loading = false;
                this.matDialog.open(ErrorModalComponent, {data: e});
              });
            location.replaceState('cooperation-invitation-response');
          } else if (!this.code) {
            console.error('could not find code in path');
            this.errOccurred = true;
          }
        }
      });
    });
  }

  getStatus(): FormState {
    if (this.loading) {
      return 'LOADING';
    }
    if (!this.providerAgent) {
      return 'NO_OFFICE_ALLOCATION';
    }

    return this.invitation.status as FormState;
  }

  deny(invitation: CooperationInvitation) {
    this.denying = true;
    this.cooperationInvitationService.put(this.providerAgent.id, invitation.id, this.code, ResponseStatus.DENIED)
      .subscribe(i => {
        this.denying = false;
        this.invitation = i;
      }, e => {
        this.denying = false;
        this.matDialog.open(ErrorModalComponent, {data: e});
      });
  }

  accept(invitation: CooperationInvitation) {
    this.accepting = true;
    this.cooperationInvitationService.put(this.providerAgent.id, invitation.id, this.code, ResponseStatus.ACCEPTED)
      .subscribe(i => {
        this.accepting = false;
        this.invitation = i;
      }, e => {
        this.accepting = false;
        this.matDialog.open(ErrorModalComponent, {data: e});
      });
  }

  getOfficeName(office: Office) {
    return office.displayName ? office.displayName : office.name;
  }
}
